import React, { useEffect, useState, useContext } from "react"; // eslint-disable-line no-unused-vars
import { makeStyles } from "@material-ui/core/styles";
import { Grid, TextField, MenuItem, Button } from "@material-ui/core";
import ScopedCssBaseline from "@material-ui/core/ScopedCssBaseline";
import {
  ThemeProvider,
  createMuiTheme,
  StylesProvider,
  createGenerateClassName,
} from "@material-ui/core/styles";
import { State } from "../store/state";
import {
  dismissAlert,
  getCategories,
  getCharities,
  setBusy,
} from "../store/actions";
import CategorySelector from "./categorySelector";
import Alert from "./alert";
import SearchResults from "./searchResults";
import zIndex from "@material-ui/core/styles/zIndex";

const App = (props) => {
  const generateClassName = createGenerateClassName({
    seed: "tbbrowse",
  });

  const theme = createMuiTheme(props.theme);
  const useStyles = makeStyles((theme) => ({
    main: { paddingTop: theme.spacing(2) },
    form: {},
    inputs: { marginBottom: theme.spacing(2) },
    selects: {
      marginBottom: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
      },
    },
    input: {
      "& input": {
        height: "100%",
        padding: "18.5px 14px",
        border: "0",
        background: "none",
      },
    },
    button: { height: "100%" },
  }));
  const classes = useStyles();
  const { state, dispatch } = useContext(State);
  const [query, setQuery] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [categoryColumnName, setCategoryColumnName] = useState("");

  const getQueryParams = (params, url) => {
    let href = url;
    let reg = new RegExp("[?&]" + params + "=([^&#]*)", "i");
    let queryString = reg.exec(href);
    return queryString ? decodeURI(queryString[1]) : "";
  };

  const search = (filter, charities) => {
    getCharities(
      { ...filter, continuationToken: null },
      charities,
      dispatch
    ).then(() => {
      let path = "?search=true";
      if (filter.categoryColumnName) {
        path = path + "&c=" + encodeURI(filter.categoryColumnName);
      }
      if (filter.postalCode) {
        path = path + "&z=" + encodeURI(filter.postalCode);
      }
      if (filter.query) {
        path = path + "&q=" + encodeURI(filter.query);
      }
      window.history.pushState(document.title, "", path);
    });
  };

  const getMore = () => {
    getCharities(
      state.searchResults.filter,
      state.searchResults.charities,
      dispatch
    );
  };

  const handleEnter = (event) => {
    if (event.code == "Enter") {
      handleSearch();
    }
  };

  const handleSearch = () => {
    search(
      {
        query: query,
        postalCode: postalCode,
        categoryColumnName: categoryColumnName,
      },
      []
    );
  };

  useEffect(() => {
    getCategories(dispatch).then(() => {
      let q = getQueryParams("q", location.href);
      let z = getQueryParams("z", location.href);
      let c = getQueryParams("c", location.href);
      if (q || zIndex || c) {
        setQuery(q);
        setPostalCode(z);
        setCategoryColumnName(c);
        search(
          {
            query: q,
            postalCode: z,
            categoryColumnName: c,
          },
          []
        );
      } else {
        setBusy(false, dispatch);
      }
    });
  }, []);

  const renderInputs = () => {
    return (
      <Grid item container xs={12} className={classes.form}>
        <Grid item xs={12} className={classes.inputs}>
          <TextField
            type="search"
            variant="outlined"
            fullWidth={true}
            className={classes.input}
            label="Keyword, Charity Name, or EIN"
            value={query}
            onKeyDown={handleEnter}
            onChange={(event) => {
              setQuery(event.target.value);
            }}
          />
        </Grid>
        <Grid item xs={12} sm={3} className={classes.inputs}>
          <TextField
            variant="outlined"
            fullWidth={true}
            className={classes.input}
            label="Zip"
            value={postalCode}
            onKeyDown={handleEnter}
            onChange={(event) => {
              setPostalCode(event.target.value);
            }}
          />
        </Grid>
        <Grid item xs={12} sm={7} className={classes.selects}>
          {state.categories && state.categories.length > 0 && (
            <TextField
              variant="outlined"
              fullWidth={true}
              className={classes.input}
              select={true}
              label="Charity Category"
              value={categoryColumnName}
              onKeyDown={handleEnter}
              onChange={(event) => {
                setCategoryColumnName(event.target.value);
              }}
            >
              <MenuItem value="*">All Categories</MenuItem>
              {state.categories.map((category) => {
                return (
                  <MenuItem key={category.id} value={category.columnName}>
                    {category.title}
                  </MenuItem>
                );
              })}
            </TextField>
          )}
        </Grid>
        <Grid item xs={12} sm={2} className={classes.inputs}>
          <Button
            variant="contained"
            className={classes.button}
            fullWidth={true}
            color="secondary"
            onClick={handleSearch}
            disabled={state.busy || state.searching}
          >
            Search
          </Button>
        </Grid>
      </Grid>
    );
  };

  return (
    <StylesProvider generateClassName={generateClassName}>
      <ThemeProvider theme={theme}>
        <ScopedCssBaseline className={classes.main}>
          {state.alerts.length > 0 && (
            <Alert
              alert={state.alerts[0]}
              onDismiss={() => {
                dismissAlert(dispatch);
              }}
            />
          )}
          {renderInputs()}
          {!state.busy && (
            <Grid item container xs={12}>
              {state.searchResults.charities.length == 0 ? (
                state.searchResults.totalCount == -1 &&
                !state.searching && (
                  <CategorySelector categories={state.categories} />
                )
              ) : (
                <SearchResults
                  searching={state.searching}
                  charities={state.searchResults.charities}
                  totalCount={state.searchResults.totalCount}
                  onGetMore={() => {
                    if (
                      !state.busy &&
                      !state.searching &&
                      state.searchResults.totalCount >
                        state.searchResults.charities.length
                    ) {
                      getMore();
                    }
                  }}
                />
              )}
            </Grid>
          )}
        </ScopedCssBaseline>
      </ThemeProvider>
    </StylesProvider>
  );
};
export default App;
